<template>
    <v-menu
        v-model="isActive"
        transition="slide-y-transition"
        offset-y>
        <template v-slot:activator="{ on, attrs }">
            <div class="cell"
                 v-bind="attrs"
                 v-on="on"
                 v-bind:style="isMobile&&value===null?'min-width: 150px;':''">

                <span>{{ list.filter(iList => iList[keyList] === value)[0]?.name || " " }}</span>
                <v-spacer/>
                <v-icon size="10" v-if="functionCheckChange" color="yellow" style="align-items: flex-start">mdi-circle</v-icon>
                <v-icon size="10" v-if="required&&value===null" color="red" style="align-items: flex-start">mdi-circle</v-icon>
                <v-icon size="8" v-bind:class="{active:isActive }" color="grey" style="margin: auto 5px;">
                    mdi-triangle-down
                </v-icon>

            </div>
        </template>
        <v-list>
            <template v-if="!(required||value===null)">
                <v-list-item  @click="$emit('change',null)">
                    <v-list-item-content>
                        <v-list-item-title>Очистить
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
            </template>
            <v-list-item
                v-for="(itemList) in list"
                :key="keyList"
                @click="$emit('change',itemList[keyList])"
                link>
                <v-list-item-content>
                    <v-list-item-title>{{ itemList.name }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: "List",
    props: {
        list: Array,
        keyList: {
            type: String,
            default: 'id',
        },
        value: null,
        functionCheckChange: function () {
        },
        isMobile: Boolean,
        required: {
            type: Boolean,
            default: false,
        },
        event: 'change'
    },
    data() {
        return {isActive: false,}
    },
}
</script>

<style scoped>
.active {
    transform: rotate(180deg);
}

.v-list {
    height: 350px; /* or any height you want */
    overflow-y: auto
}


.update-dot {
    margin-top: 3px;
}

.error-dot {
    margin-top: 3px;
}

.cell {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    flex-direction: row;
}
</style>